<template>
  <div class="pagination" :class="{ isDisabled: disabled }">
    <div class="disable-overlay"></div>
    <div class="pagination-pages">
      <div class="pagination-info">
        {{ pagination.page }} of
        {{ pagination.count ? pagination.count : 1 }} pages
      </div>
      <div class="pagination-page">
        <el-button class="btn-page prev" :disabled="is_min" @click="prev()">
          <img src="./icons/prev.svg" />
        </el-button>
        <!-- select is lagging on huge count of options       -->
        <el-select
          v-if="pagination.count < 500"
          v-model="pagination.page"
          @change="change()"
          :disabled="pagination.count < 2">
          <el-option
            v-for="page in page_list"
            :key="page"
            :label="page"
            :value="page"></el-option>
        </el-select>
        <span v-else>{{ pagination.page }}</span>
        <el-button class="btn-page next" :disabled="is_max" @click="next()">
          <img src="./icons/next.svg" />
        </el-button>
      </div>
    </div>
    <div class="pagination-limit">
      <div class="pagination-info">Items per page:</div>
      <el-select v-model="pagination.limit" @change="change(true)">
        <el-option
          v-for="(limit, key) in limit_list"
          :key="key"
          :label="limit"
          :value="limit"></el-option>
      </el-select>
      <div class="pagination-info">
        {{ limit.from }} - {{ limit.to }} of {{ pagination.total }} items
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pagination", "disabled"],

  data() {
    return {
      limit_list: [10, 25, 50, 100, 200],
    };
  },

  methods: {
    // предыдущая страница
    prev: function () {
      if (!this.is_min) {
        this.pagination.page--;
        this.change();
      }
    },

    // следующая страница
    next: function () {
      if (!this.is_max) {
        this.pagination.page++;
        this.change();
      }
    },

    // генерация события изменения пагинации
    change: function (is_limit) {
      if (is_limit) {
        this.pagination.page = 1;
      }

      this.$emit("change", this.pagination);
    },
  },
  computed: {
    // определение минимальной разрешенной страницы для disabled кнопок пагинации
    is_min: function () {
      return this.pagination.page <= 1;
    },

    // определение максимальной разрешенной страницы для disabled кнопок пагинации
    is_max: function () {
      return this.pagination.page >= this.pagination.count;
    },

    // генерация списка страниц для отображения в select
    page_list: function () {
      let list = [];
      for (let n = 1; n <= this.pagination.count; n++) {
        list.push(n);
      }
      return list;
    },

    limit: function () {
      let limit = {
        from: 0,
        to: 0,
      };

      if (this.pagination.total) {
        limit = {
          from: this.pagination.limit * (this.pagination.page - 1) + 1,
          to: Math.min(
            this.pagination.limit * this.pagination.page,
            this.pagination.total
          ),
        };
      }

      return limit;
    },
  },
};
</script>

<style lang="sass"></style>
